import Auth from '../auth/Auth';
import AuthStorage from '../auth/AuthStorage';
import LogoutDomService from '../auth/LogoutDomService';

const logoutDomService = new LogoutDomService();
const storage = new AuthStorage(window.localStorage);

let facade;

document.querySelectorAll('[data-action="logout"]').forEach(button => {
    if (!button) return;

    button.addEventListener('click', () => {
        facade = new Auth(storage, logoutDomService.getToken());

        storage.forgetAll();
        facade.logout(logoutDomService.getEndpoint());
    });
});
